import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { APIService } from '../api.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatPaginator } from '@angular/material/paginator';

@Component({
  selector: 'app-invoice-status',
  templateUrl: './invoice-status.component.html',
  styleUrls: ['./invoice-status.component.scss']
})
export class InvoiceStatusComponent implements OnInit {

  dataSource = new MatTableDataSource();
  @ViewChild('LRTable', { static: false }) LRTable!: ElementRef;
  @ViewChild(MatSort) sort!: MatSort;
  @Input() mdlRef: any;
  @Input() relID: any;
  
  @ViewChild(MatPaginator)
  set paginator(value: MatPaginator) {
    this.dataSource.paginator = value;
  }

  @ViewChild(MatSort) set matSort(sort: MatSort) {
    this.dataSource.sort = sort;
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  displayedColumns: string[] = [
    'InvoiceNo',    
    'date',
    'status',
    'pndgAmt',
    'recdAmt'
  ];
  jarvisData: Array<any> = [];
  agencyData: Array<any> = [];
  invoiceList: Array<any> = [];
  agencyName: string = "";

  constructor(private modalService: NgbModal, private apiService: APIService, private SpinnerLoader: NgxSpinnerService) { }

  ngOnInit(): void {
    let jarvis = this.apiService.getCookie('Jarvis');
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }

    let agencyData = this.apiService.getCookie('M');
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
    }

    //Get H from IDB
    var self = this;
    let hCook = this.apiService.getIDB('H', function(data: any){
      if(data){
        let selectedAgency = data.filter((o: any) => o.RI == self.relID);
          if(selectedAgency.length > 0){
            self.agencyName = selectedAgency[0].Cmp;
          }
      }
    })

    this.getPndgGetInvList();
  }

  //getPndgGetInvList() - Get Invoice List
  getPndgGetInvList(){
    let tmpData = [{
      'relativeID': this.relID,
      'type': 'DINV',
      'month': new Date().getMonth() + 1,
      'year': new Date().getFullYear()
    }];

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      myLastSyncDT: null,
      isWeb: true,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      actionType: 'relDocs',
      moduleID: 10,
      data: JSON.stringify(tmpData),
    }];

    this.SpinnerLoader.show();
    this.apiService.getData(
      myParams,
      this.successResp.bind(this),
      this.failureResp.bind(this)
    );

  }

  //successResp - success  get handler
  successResp(res: any) {
    this.SpinnerLoader.hide();
    if (res.error) {
    } else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);        
        console.log("Invoice Status", reponseData);
        if (reponseData) {
          var data = reponseData;
          if (data.Table[0].ErrCode == '1') {
            alert(data.Table[0].ErrMsg);
            return;
          }
          this.invoiceList = data.Table1;
          this.invoiceList = this.invoiceList.filter((o: any) => o.PndgAmt > 0);
          this.invoiceList.forEach(function(o){
            o.PmtExpDT = new Date(o.PmtExpDT);
            o.receivedAmt = "";
            o.PndgAmt = o.PndgAmt == null ? 0 : o.PndgAmt;
            o.status = o.PndgAmt == 0 ? 'Fully Paid' : ((o.GrandTotal != o.PndgAmt && o.PndgAmt > 0) ? 'Partly Paid' : 'Unpaid')
          });
          console.log("Jaimin", this.invoiceList);
          this.dataSource.data = this.invoiceList;
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.matSort;
        }
      }
    }
  }

  //failureResp - failure handler
  failureResp(res: any) {
    this.SpinnerLoader.hide();
    if (res.error) {
    } else {
      alert(res.message);
    }
  }

  //fn_changePaymentStatus() - Change Payment Status
  fn_changePaymentStatus(ind: number){
    if(ind > -1){
      if(this.invoiceList[ind].status == 'Fully Paid') {
        this.invoiceList[ind].receivedAmt = this.invoiceList[ind].GrandTotal;
      }
      else if(this.invoiceList[ind].status == 'Partly Paid') {
        this.invoiceList[ind].receivedAmt = '';
      }
      else {
        this.invoiceList[ind].receivedAmt = 0;
      }
    }
  }

  //fn_changeRecoveryAmt() - 
  fn_changeRecoveryAmt(ind: number){
    if(ind > -1){
      if(this.invoiceList[ind].receivedAmt == ""){
        return;
      };
      let oldStatus: string = this.invoiceList[ind].status;
      if(Number(this.invoiceList[ind].receivedAmt) > Number(this.invoiceList[ind].PndgAmt)){
        this.apiService.successAlert("Please ensure that the amount received against the invoice does not exceed the invoice pending amount.");
        this.invoiceList[ind].receivedAmt = "";
        this.invoiceList[ind].status = oldStatus;
        return;
      }
      this.invoiceList[ind].status = (this.invoiceList[ind].receivedAmt == this.invoiceList[ind].PndgAmt ? "Fully Paid" : ((this.invoiceList[ind].GrandTotal != this.invoiceList[ind].receivedAmt && this.invoiceList[ind].receivedAmt > 0) ? 'Partly Paid' : 'Unpaid'));
    };
  }

  //fn_SaveUpdateInvStatus() - Update Invoice Status
  fn_SaveUpdateInvStatus(){
    let finalInvvoiceStatus: Array<any> = [];
    let totalRecdAmt: number = 0;
    this.invoiceList.forEach(function(i){
      if(String(i.receivedAmt) != '' && String(i.receivedAmt) != "-"){
        totalRecdAmt = totalRecdAmt + Number(i.receivedAmt);
        let pendingAmt = (i.status == 'Fully Paid' ? 0 : (i.status == 'Unpaid' ? i.GrandTotal : (Number(i.PndgAmt) - i.receivedAmt)));
        finalInvvoiceStatus.push({         
          RelativeID: i.BuyerRelIDInSeller,
          DocID: i.DocID,
          DoneAmt: i.receivedAmt,
          PndgAmt: Number(pendingAmt).toFixed(2)
        });
      }
    });

    if(finalInvvoiceStatus.length == 0){
      this.apiService.successAlert("Please entera a atleast one invoice receivable amount.");
      return;
    };

    let tempData: Array<any> = [{
        'CstrRelID': this.relID,
        'PndgInvData': JSON.stringify(finalInvvoiceStatus) 
    }];

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      myLastSyncDT: null,
      isWeb: true,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      actionType: 'setDocPndgAmt',
      moduleID: 10,
      data: JSON.stringify(tempData),
    }];

    this.SpinnerLoader.show();
    this.apiService.sendChange(
      myParams,
      this.successPndgAmt.bind(this),
      this.failureResp.bind(this)
    );
  };

  successPndgAmt(res: any){
    this.SpinnerLoader.hide();
    if (res.error) {
    } else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage); 
        if (reponseData) {
          var data = reponseData;
          if (data.Table[0].ErrCode != '-1') {
            alert(data.Table[0].ErrMsg);
            return;
          }
          else{
            this.apiService.successAlert("Invoice Status updated.");
            this.closeInvoiceStatus();
          }
        }
      }
    }
  }

  //closeInvoiceStatus() - Close Invoice Status Modal
  closeInvoiceStatus(){
    this.mdlRef.close();
  }
}
